function Footer(){
    return(
        <div style={{display:"flex",width:"100%",height:"400px",backgroundColor:"rgb(229, 226, 226)"}}>
           <div style={{ paddingLeft:"150px",paddingTop:"40px"}}>
            <p>Help</p>
            <p>Track Order</p>
            <p>Returns and exchanges</p>
            <p>Shipping</p>
            <p >International Order</p>
            <p>Contact Order</p>
           </div>
           <div style={{paddingLeft:"150px",paddingTop:"40px"}}>
            <p>Quick Links</p>
            <p>Size Charts</p>
            <p>Find a Store</p>
            <p>Offers and Promotions</p>
           </div>
           <div style={{paddingLeft:"150px",paddingTop:"40px"}}>
            <p>About J.crew</p>
            <p>Our Story</p>
            <p>Carrers</p>
            <p>Social Responsibility</p>
            <p>Investors Relations</p>
            <p>Terms of use</p>
            <p>Privacy Policy</p>
           </div>
           <div></div>
        </div>
    )
}
export default Footer;